import { useQuery, keepPreviousData } from '@tanstack/react-query';
// import { leadService } from "@/pages/sd-leads/leads/services/leadService";
const leadService = { getLeads: async () => ({ data: [] }) };

export const useDateFilteredLeads = (params = {}, filters = {}) => {
  const query = useQuery({
    queryKey: ['sd-leads', params, filters],
    queryFn: async () => {
      const response = await leadService.getLeads(params);
      return response?.data || response;
    },
    placeholderData: keepPreviousData,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};




